import React from "react";
import { BsArrowDownShort, BsArrowUpShort } from "react-icons/bs";
import {
	getTrendClassName,
	getTrendLabel,
	hasTrend,
	isFallingTrend
} from "../../utils/dashboard-trend-utils";
import Select from "../../../../components/selects/select";
import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";
import TooltipGeneric from "../../../../shared/components/generic/tooltip/tooltip-generic";
import "./sales-summary.css";


const DashboardDailySalesSummary = ({
	dailySales = {},
	isClosedCycle = false,
	dailyAverageTarget = "",
	dailyAverageTargetOptions = [],
	onDailyAverageTargetChange,
	growthToTarget = 0
}) => {
	const dailyTrend = dailySales?.trend || dailySales?.tendencia;
	const isFalling = isFallingTrend(dailyTrend);
	const TrendIcon = isFalling ? BsArrowDownShort : BsArrowUpShort;
	const dailyDiscountPercentage = dailySales?.discountPercentage ?? 0;

	if (isClosedCycle) {
		return (
			<div className="dashboard-sales-summary dashboard-sales-summary--daily dashboard-sales-summary--closed-cycle">
				<div className="dashboard-sales-summary__metrics">
					<div className="dashboard-sales-summary__discount">
						<span>Desconto alcançado no ciclo:</span>

						<strong className="dashboard-percentage-pill">
							{MonetaryUtils.formatPercentage(dailyDiscountPercentage)}
						</strong>
					</div>

					<p>
						<span>Vendas médias diárias neste ciclo:</span>
						<strong>{MonetaryUtils.formatCurrency(dailySales?.dailyAverage ?? 0)}</strong>
					</p>

					<p>
						<span>Dias úteis corridos no ciclo:</span>
						<strong>{dailySales?.elapsedBusinessDays ?? 0}</strong>
					</p>
				</div>
			</div>
		);
	}

	return (
		<div className="dashboard-sales-summary dashboard-sales-summary--daily">
			<div className="dashboard-sales-summary__metrics">
				<div className="dashboard-sales-summary__discount">
					<span>Projeção de desconto no ciclo:</span>

					<strong className="dashboard-percentage-pill">
						{MonetaryUtils.formatPercentage(dailyDiscountPercentage)}
					</strong>

					<TooltipGeneric
						content="Opção para justificar resultado final."
						iconSize={16}
						placement="top"
					/>
				</div>
				<p className="dashboard-sales-summary__metric--highlight">
					<span className="dashboard-sales-summary__metric-main">
						<span>Projeção de média diária acumulada no fim deste mês:</span>

						<span className="dashboard-sales-summary__metric-result">
							<strong>
								{MonetaryUtils.formatCurrency(
									dailySales?.projectedAccumulatedAverage ??
									dailySales?.dailyAverage ??
									0
								)}
							</strong>

							{hasTrend(dailyTrend) && (
								<span className={getTrendClassName(dailyTrend)}>
									<TrendIcon size={18} />
									<span>{getTrendLabel(dailyTrend)}</span>
								</span>
							)}
						</span>
					</span>
				</p>

				<p>
					<span>Vendas médias diárias neste mês:</span>
					<strong>{MonetaryUtils.formatCurrency(dailySales?.dailyAverage ?? 0)}</strong>
				</p>

				<p>
					<span>Dias úteis corridos no ciclo:</span>
					<strong>{dailySales?.elapsedBusinessDays ?? 0}</strong>
				</p>

				<p>
					<span>Dias úteis restantes no ciclo:</span>
					<strong>{dailySales?.remainingBusinessDays ?? 0}</strong>
				</p>
			</div>

			<div className="dashboard-sales-summary__target">
				<strong className="dashboard-sales-summary__target-title">
					Crescimento médio diário necessário para alcançar a meta
				</strong>

				<div className="dashboard-sales-summary__target-row">
					<span className="dashboard-sales-summary__target-label">Meta:</span>

					<Select
						name="dailyAverageTarget"
						value={dailyAverageTarget}
						itens={dailyAverageTargetOptions}
						onChange={onDailyAverageTargetChange}
						width="88px"
						className="dashboard-sales-summary__select"
					/>

					<span>Crescimento médio diário:</span>

					<strong className="dashboard-sales-summary__target-value">
						{MonetaryUtils.formatCurrency(growthToTarget)}
					</strong>
				</div>
			</div>
		</div>
	);
};

export default DashboardDailySalesSummary;